import '../../css/modules/comparisonSlider.less'
import ComparisonSliderAnimation from './comparisonSlider/ComparisonSliderAnimation'
import ScrollMagic from 'scrollmagic'

export default class ComparisonsImagesSlider {
  constructor() {
    this._clicked = false
    this._containerWidth = 0
    this._container = document.querySelector('.comparison-images-slider')
    if (this._container) {
      this._overlayImg = this._container.querySelector('.img-comp-overlay')
      this._overlayImgWidth = this._overlayImg.offsetWidth
      this.setContainerWidth(this._container)
      this._slider = document.createElement('DIV')
      this._overlayImg.parentElement.insertBefore(this._slider, this._overlayImg)
      this._slider.setAttribute('class', 'img-comp-slider')
      const sliderPosition = this._overlayImgWidth / 2 - this._slider.offsetWidth / 2 - 2
      this.slide(sliderPosition)
      this._slider.addEventListener('mousedown', e => this.slideReady(e))
      this._slider.addEventListener('touchstart', e => this.slideReady(e))
      window.addEventListener('mouseup', e => this.slideFinish(e))
      window.addEventListener('touchstop', e => this.slideFinish(e))
      this.Animation = new ComparisonSliderAnimation(this._containerWidth, sliderPosition)
      this.initAnimation()
    }
  }

  setContainerWidth(container) {
    const imgWidth = container.querySelector('img').clientWidth
    this._containerWidth = imgWidth
    container.style.width = `${imgWidth}px`
  }

  slideReady(e) {
    e.preventDefault()
    this._clicked = true
    window.addEventListener('mousemove', e => this.slideMove(e))
    window.addEventListener('touchmove', e => this.slideMove(e))
  }

  slideFinish() {
    this._clicked = false
  }

  slideMove(e) {
    let pos
    if (this._clicked == 0) return false
    pos = this.getCursorPos(e)
    if (pos < 0) pos = 0
    if (pos > this._overlayImgWidth) pos = this._overlayImgWidth
    this.Animation.setSlidePosition(pos)
    this.slide(pos, this._overlayImg)
  }

  getCursorPos(e) {
    let a,
      x = 0
    e = e || window.event
    a = this._overlayImg.getBoundingClientRect()
    x = e.pageX - a.left
    x = x - window.pageXOffset
    return x
  }

  slide(x) {
    this._overlayImg.style.width = x + 'px'
    this._slider.style.transform = `translateX(${this._overlayImg.offsetWidth - this._slider.offsetWidth / 2 + 'px'})`
  }

  initAnimation() {
    const controller = new ScrollMagic.Controller()
    new ScrollMagic.Scene({
      triggerElement: this._container,
      duration: '100%'
    })
      .addTo(controller)
      .on('enter', () => {
        this._slider.classList.toggle('pulse-fade')
      })
  }
}
